<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div class="uk-width-1-1">
      <div class="uk-align-right">
        <a href="#" @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
          <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
          Zurück
        </a>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
        <div class="uk-card-body">
          <div class="uk-grid" uk-grid>
            <div class="uk-width-1-1">
              <label class="uk-form-label uk-text-bold">Preisberechnung</label>
              <div class="uk-grid-small uk-child-width-auto uk-grid">
                <label><input class="uk-radio" type="radio" value="net" v-model="form.priceType" /> Netto</label>
                <label><input class="uk-radio" type="radio" value="gross" v-model="form.priceType" /> Brutto</label>
              </div>
            </div>
            <div class="uk-width-1-2@m">
              <div class="uk-margin">
                <label class="uk-form-label uk-text-bold">Preisaufschlag für Verbraucher</label>
                <div class="uk-inline uk-display-block">
                  <span class="uk-form-icon uk-form-icon-flip">€</span>
                  <input class="uk-input uk-form-small" id="endcustomer" type="text" v-model="form.main.endcustomer" />
                </div>
                <span class="uk-text-small uk-text-muted">Nur ganze Zahlen, z. B. 1000</span>
              </div>
            </div>
            <div class="uk-width-1-2@m">
              <div class="uk-margin">
                <label class="uk-form-label uk-text-bold" for="dealer">Preisaufschlag für Händler</label>
                <div class="uk-inline uk-display-block">
                  <span class="uk-form-icon uk-form-icon-flip">€</span>
                  <input
                    class="uk-input uk-form-small"
                    id="dealer"
                    name="dealer"
                    type="text"
                    v-model="form.main.dealer"
                  />
                </div>
                <span class="uk-text-small uk-text-muted">Nur ganze Zahlen, z. B. 1000</span>
              </div>
            </div>
            <div class="uk-width-1-1">
              <div class="uk-align-right">
                <button class="uk-button uk-button-primary" @click.prevent="store">
                  Speichern
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="uk-card uk-card-small uk-card-default uk-box-shadow-small uk-margin-bottom">
        <div class="uk-card-body">
          <div class="uk-grid uk-child-width-1-1" uk-grid>
            <div>
              <div class="uk-text-large">
                Hier können Sie spezielle Aufschläge je Marke und Modell eingeben
              </div>
            </div>

            <div>
              <table class="uk-table uk-table-justify uk-table-divider uk-table-hover">
                <thead>
                  <tr>
                    <th class="uk-width-small">Marke</th>
                    <th>Model</th>
                    <th>Verbraucher</th>
                    <th>Händler</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(make, i) in makes">
                    <tr :key="i">
                      <td>{{ make.label }}</td>
                      <td>Alle Modelle</td>
                      <td>
                        <div class="uk-inline uk-display-block">
                          <span class="uk-form-icon uk-form-icon-flip">€</span>
                          <input
                            class="uk-input uk-form-small"
                            type="text"
                            v-model="form.detail.endcustomer[`${make.value}_all`]"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="uk-inline uk-display-block">
                          <span class="uk-form-icon uk-form-icon-flip">€</span>
                          <input
                            class="uk-input uk-form-small"
                            type="text"
                            v-model="form.detail.dealer[`${make.value}_all`]"
                          />
                        </div>
                      </td>
                    </tr>
                    <tr v-for="model in make.models" :key="model.id">
                      <td>&nbsp;</td>
                      <td>{{ model.label }}</td>
                      <td>
                        <div class="uk-inline uk-display-block">
                          <span class="uk-form-icon uk-form-icon-flip">€</span>
                          <input
                            class="uk-input uk-form-small"
                            type="text"
                            v-model="form.detail.endcustomer[`${make.value}_${model.value}`]"
                          />
                        </div>
                      </td>
                      <td>
                        <div class="uk-inline uk-display-block">
                          <span class="uk-form-icon uk-form-icon-flip">€</span>
                          <input
                            class="uk-input uk-form-small"
                            type="text"
                            v-model="form.detail.dealer[`${make.value}_${model.value}`]"
                          />
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <div>
              <div class="uk-align-right">
                <button class="uk-button uk-button-primary" @click.prevent="store">
                  Speichern
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SurchargeService from '@/services/surcharge.service'
import VehicleService from '@/services/vehicle.service'
import 'izitoast/dist/css/iziToast.min.css'
import iziToast from 'izitoast/dist/js/iziToast.min.js'

export default {
  data() {
    return {
      makes: [],
      form: {
        priceType: 'net',
        main: {
          endcustomer: 0,
          dealer: 0
        },
        detail: {
          endcustomer: {},
          dealer: {}
        }
      }
    }
  },
  mounted() {
    this.getMakeModels()
  },
  methods: {
    getMakeModels() {
      VehicleService.getMakes().then(response => {
        this.makes = response.data
        this.getSurchargeConfig()
      })
    },
    getSurchargeConfig() {
      SurchargeService.get().then(response => {
        this.form = {
          priceType: response.data.priceType,
          main: {
            endcustomer: response.data.main.endcustomer || 0,
            dealer: response.data.main.dealer || 0
          },
          detail: {
            endcustomer: response.data.detail.endcustomer || {},
            dealer: response.data.detail.dealer || {}
          }
        }
      })
    },
    async store() {
      await SurchargeService.store(this.form)

      iziToast.success({
        title: 'OK',
        message: 'Einstellungen gespeichert!',
        timeout: 5000,
        position: 'topCenter'
      })
    }
  }
}
</script>
